import { __extends } from "tslib";
import React from 'react';
import numeral from 'numeral';
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { withTranslation } from 'react-i18next';
import { Formik, Form, Field } from 'formik';
import { EditorFlavourConfigs } from '../DaEditorWrapper/config';
import { default as CommissionConfirmation, } from './CommissionConfirmation';
import get from 'lodash/get';
import FormPopup from '../Popup/Form';
import Points from '../Icons/Points';
import Input from '../Input';
import DaEditorWrapper from '../DaEditorWrapper/LoadableDaEditorWrapper';
import DaEditorMobileFullscreenPopup from '../DaEditorWrapper/MobileFullscreenPopup';
import { convertToClientStorageState } from '../DaEditorWrapper/utils';
import TextRenderer from '../TextRenderer';
import CommissionViewer from '../DaEditorWrapper/Viewer/Commission';
import { withMobileContext } from '../Context';
import mergeTheme from '../DaEditorWrapper/Themes/mergeTheme';
// Merge the text theme with the editor theme (content vs editor toolbars etc)
import textTheme from '../DaEditorWrapper/Themes/Viewer/commission.scss';
import editorTheme from '../DaEditorWrapper/Themes/Editor/commission.scss';
var commissionTheme = mergeTheme(textTheme, editorTheme);
import s from './CommissionEditPopup.scss';
import LoadingIndicator from '../LoadingIndicator';
export var InputNames;
(function (InputNames) {
    InputNames["Title"] = "title";
    InputNames["PointsCost"] = "pointsCost";
})(InputNames || (InputNames = {}));
var DA_PROFIT_MARGIN = 0.2;
var POINTS_IN_ONE_DOLLAR = 80;
var TITLE_MIN_LENGTH = 4;
var TITLE_MAX_LENGTH = 80;
var POINTS_VALUE_STEP = 10;
var POINTS_MIN_VALUE = 10;
var POINTS_MAX_VALUE = 8000;
var SCROLL_TO_INPUTS = [InputNames.Title, InputNames.PointsCost];
var CommissionEdit = /** @class */ (function (_super) {
    __extends(CommissionEdit, _super);
    function CommissionEdit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            footerToolbar: undefined,
            confirmationPopupType: null,
            openMobileDescriptionEditor: false,
            mobileEditorDone: false,
        };
        _this.inputRefs = {};
        _this.getInputRefHandler = function (fieldName) { return function (ref) {
            _this.inputRefs[fieldName] = ref;
        }; };
        _this.handleSubmit = function (form) {
            if (_this.props.deviation) {
                var _a = _this.props, deviation = _a.deviation, updateCommission = _a.updateCommission;
                updateCommission({
                    commissionid: deviation.deviationId,
                    title: form.title,
                    pointsCost: form.pointsCost,
                    editorRawState: _this.editorRawState,
                    editorContent: _this.editorContent,
                    features: _this.editorFeatures,
                });
            }
            else {
                _this.props.createCommission({
                    title: form.title,
                    pointsCost: form.pointsCost,
                    editorRawState: _this.editorRawState,
                    editorContent: _this.editorContent,
                    features: _this.editorFeatures,
                });
            }
            _this.props.onClose();
        };
        _this.scrollInvalidIntoView = function (errors) {
            var invalidInputNames = Object.keys(errors);
            for (var i = 0; i < SCROLL_TO_INPUTS.length; i++) {
                var inputName = SCROLL_TO_INPUTS[i];
                if (invalidInputNames.includes(inputName)) {
                    _this.inputRefs[inputName].focus();
                    break;
                }
            }
        };
        _this.validateTitle = function (value) {
            if (!value) {
                return _this.props.t('commission.validation.title.required');
            }
            else if (value.trim().length < TITLE_MIN_LENGTH ||
                value.trim().length > TITLE_MAX_LENGTH) {
                return _this.props.t('commission.validation.title.lengthExceeded', {
                    min: TITLE_MIN_LENGTH,
                    max: TITLE_MAX_LENGTH,
                });
            }
            return undefined;
        };
        _this.validatePrice = function (value) {
            if (!value) {
                return _this.props.t('commission.validation.pointsCost.required');
            }
            else if (value < POINTS_MIN_VALUE) {
                return _this.props.t('commission.validation.pointsCost.min', {
                    min: POINTS_MIN_VALUE,
                });
            }
            else if (value > POINTS_MAX_VALUE) {
                return _this.props.t('commission.validation.pointsCost.max', {
                    max: POINTS_MAX_VALUE,
                });
            }
            else if (value % POINTS_VALUE_STEP !== 0) {
                return _this.props.t('commission.validation.pointsCost.isDivisibleBy', {
                    step: POINTS_VALUE_STEP,
                });
            }
            return undefined;
        };
        _this.validateForm = function (values) {
            var errors = {
                pointsCost: _this.validatePrice(values.pointsCost),
                title: _this.validateTitle(values.title),
            };
            Object.keys(errors).forEach(function (key) { return errors[key] === undefined && delete errors[key]; });
            return errors;
        };
        _this.handleUnsavedClose = function () {
            _this.setState({
                confirmationPopupType: !_this.props.deviation
                    ? 'leaveCreating'
                    : 'discardChanges',
            });
        };
        _this.onCancelCloseConfirmation = function () {
            _this.setState({ confirmationPopupType: undefined });
        };
        _this.onConfirmCloseConfirmation = function () {
            _this.setState({ confirmationPopupType: undefined });
            _this.props.onClose();
        };
        _this.handleOpenMobileDescriptionEdit = function () {
            _this.setState({ openMobileDescriptionEditor: true });
        };
        _this.handleCloseMobileDescriptionEdit = function () {
            _this.setState({ openMobileDescriptionEditor: false });
        };
        _this.handleMobileEditDone = function (rawContentState, editorContent, featuresData) {
            _this.editorRawState = rawContentState;
            _this.editorContent = editorContent;
            _this.editorFeatures = featuresData;
            _this.setState({
                openMobileDescriptionEditor: false,
                mobileEditorDone: true,
            });
        };
        _this.handleEditorInit = function (toolbars) {
            if (!_this.state.footerToolbar && toolbars.FOOTER) {
                _this.setState({ footerToolbar: toolbars.FOOTER });
            }
        };
        _this.handleEditorChange = function (rawContentState, editorContent, featuresData) {
            _this.setState({ editorDirty: true });
            _this.editorRawState = rawContentState;
            _this.editorContent = editorContent;
            _this.editorFeatures = featuresData;
        };
        return _this;
    }
    CommissionEdit.prototype.renderForm = function () {
        var _this = this;
        var commission = this.props.deviation && this.props.deviation.commission;
        var initialValues = {
            title: (commission && commission.title) || '',
            description: get(commission, 'textContent.html.markup', ''),
            pointsCost: (commission && commission.pointsCost) || '',
        };
        var _a = this.props, deviation = _a.deviation, onClose = _a.onClose, t = _a.t, isMobile = _a.isMobile;
        var artistPointsProfit;
        return (React.createElement(Formik, { initialValues: initialValues, onSubmit: this.handleSubmit, validate: this.validateForm, render: function (_a) {
                var submitForm = _a.submitForm, dirty = _a.dirty, isSubmitting = _a.isSubmitting, values = _a.values, errors = _a.errors, setFieldValue = _a.setFieldValue, setTouched = _a.setTouched;
                var isDirty = dirty || _this.state.editorDirty;
                return (React.createElement(FormPopup, { className: s['root'], isOpen: true, title: t(deviation
                        ? 'commission.editCommission'
                        : 'commission.newCommission'), onSubmit: function () {
                        var _a;
                        setTouched((_a = {},
                            _a[InputNames.Title] = true,
                            _a[InputNames.PointsCost] = true,
                            _a));
                        isEmpty(errors)
                            ? submitForm()
                            : _this.scrollInvalidIntoView(errors);
                    }, onCancel: isDirty ? _this.handleUnsavedClose : onClose, onClose: isDirty ? _this.handleUnsavedClose : onClose, cancelBtnLabel: t('common.cancel'), submitBtnLabel: deviation ? t('commission.save') : t('commission.create'), disabledSubmit: !isDirty || isSubmitting },
                    React.createElement(Form, { onSubmit: submitForm },
                        React.createElement(Field, { name: InputNames.Title, render: function (_a) {
                                var field = _a.field, form = _a.form;
                                return (React.createElement("div", null,
                                    React.createElement(Input, { refInput: _this.getInputRefHandler(field.name), value: field.value, name: field.name, onBlur: field.onBlur, label: _this.props.t('commission.giveTitle'), onChange: function (value) { return setFieldValue(field.name, value); }, type: "text", autoComplete: "off", error: form.touched.title && form.errors.title, errorMessage: form.touched.title && form.errors.title, maxLength: TITLE_MAX_LENGTH })));
                            } }),
                        _this.renderDesktopEditor(),
                        _this.renderMobileEditor(),
                        React.createElement("div", { className: s['points-cost-line'] },
                            React.createElement(Field, { name: InputNames.PointsCost, render: function (_a) {
                                    var field = _a.field, form = _a.form;
                                    return (React.createElement("div", null,
                                        React.createElement(Input, { refInput: _this.getInputRefHandler(field.name), value: field.value, name: field.name, onBlur: field.onBlur, type: "number", className: s['points-cost-input'], label: _this.props.t('commission.choosePrice'), onChange: function (value) { return setFieldValue(field.name, value); }, step: POINTS_VALUE_STEP, minValue: POINTS_MIN_VALUE, maxValue: POINTS_MAX_VALUE, autoComplete: "off", error: form.touched.pointsCost && form.errors.pointsCost, errorMessage: (form.values.pointsCost ||
                                                form.touched.pointsCost) &&
                                                form.errors.pointsCost })));
                                } }),
                            !isMobile && (React.createElement("div", { className: s['input-label'] },
                                React.createElement(Points, { className: s['coins-icon'] }),
                                t('common.points', {
                                    count: parseInt(values.pointsCost),
                                }))))),
                    React.createElement("div", { className: s['earnings-line'] },
                        !errors.pointsCost && values.pointsCost && (React.createElement(React.Fragment, null,
                            React.createElement("span", { className: s['earnings-line__your-earnings'] },
                                t('commission.yourEarnings'),
                                ":",
                                ' '),
                            React.createElement("span", { className: s['earnings-line__points'] }, !errors.pointsCost && values.pointsCost && (React.createElement(React.Fragment, null,
                                "\u00A0",
                                (artistPointsProfit =
                                    parseInt(values.pointsCost) *
                                        (1 - DA_PROFIT_MARGIN)),
                                "\u00A0",
                                t('common.points', {
                                    count: artistPointsProfit,
                                }),
                                "\u00A0 (",
                                numeral(artistPointsProfit / POINTS_IN_ONE_DOLLAR).format('$0,0.00'),
                                ")"))))),
                        React.createElement("a", { target: "_blank" // eslint-disable-line react/jsx-no-target-blank
                            , href: "https://about.deviantart.com/points/", className: s['price-faq'] }, t('common.faq.whatArePoints')))));
            } }));
    };
    CommissionEdit.prototype.renderDesktopEditor = function () {
        var _a = this.props, deviation = _a.deviation, t = _a.t, isMobile = _a.isMobile;
        if (isMobile) {
            return null;
        }
        var description;
        if (get(deviation, 'commission.textContent.html.type') !== 'writer') {
            description = get(deviation, 'commission.textContent');
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classnames(s['editor-wrapper'], 'da-editor-commission') },
                React.createElement(DaEditorWrapper, { loadingComponent: LoadingIndicator, flavour: EditorFlavourConfigs.COMMISSION, onEditorInit: this.handleEditorInit, onContentChange: this.handleEditorChange, theme: commissionTheme, initialContent: description, placeholder: t('commission.editor.placeholder'), filterPaste: true })),
            this.renderFooterToolbar()));
    };
    CommissionEdit.prototype.renderMobileEditor = function () {
        var _a = this.props, deviation = _a.deviation, t = _a.t, isMobile = _a.isMobile;
        if (!isMobile) {
            return null;
        }
        var _b = this.state, mobileEditorDone = _b.mobileEditorDone, openMobileDescriptionEditor = _b.openMobileDescriptionEditor;
        // If they have edited the text in the fullscreen editor
        // we switch the text to that version
        var description;
        if (get(deviation, 'commission.textContent.html.type') !== 'writer') {
            description = get(deviation, 'commission.textContent');
        }
        if (mobileEditorDone) {
            description = convertToClientStorageState(this.editorRawState, this.editorContent, this.editorFeatures).editorText;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classnames(s['editor-wrapper'], s['editor-wrapper-mobile']), onClick: this.handleOpenMobileDescriptionEdit },
                !description && t('commission.editor.placeholder'),
                React.createElement(TextRenderer, { textContent: description, reactViewer: CommissionViewer, viewerKey: deviation && deviation.deviationId })),
            React.createElement(DaEditorMobileFullscreenPopup, { flavour: EditorFlavourConfigs.COMMISSION, isOpen: openMobileDescriptionEditor, theme: editorTheme, placeholder: t('commission.editor.placeholder'), title: t('commission.editor.mobile.title'), onDone: this.handleMobileEditDone, onCancel: this.handleCloseMobileDescriptionEdit, initialContent: description })));
    };
    CommissionEdit.prototype.renderFooterToolbar = function () {
        var footerToolbar = this.state.footerToolbar;
        if (!footerToolbar) {
            return;
        }
        var FooterToolbar = footerToolbar;
        return (React.createElement("div", { className: editorTheme['editor-footer'] },
            React.createElement(FooterToolbar, null)));
    };
    CommissionEdit.prototype.renderConfirmations = function () {
        return (this.state.confirmationPopupType && (React.createElement(CommissionConfirmation, { isOpen: true, confirmationType: this.state.confirmationPopupType, onCancel: this.onCancelCloseConfirmation, onConfirm: this.onConfirmCloseConfirmation })));
    };
    CommissionEdit.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            this.renderForm(),
            this.renderConfirmations()));
    };
    return CommissionEdit;
}(React.Component));
export { CommissionEdit };
export default withMobileContext(withTranslation()(CommissionEdit));
//# sourceMappingURL=CommissionEditPopup.js.map